// Local restrictions remain necessary even when the backend reports eligibility.
export function getFinancialReportLocalDisabledReason({
  tenantId,
  companyId,
  requesterId,
  tenant,
  tenantLoading,
  tenantError,
  permissions,
  permissionsLoading,
  isSupportPreview,
} = {}) {
  if (!tenantId || !companyId) {
    return 'Select a company before generating a financial report.';
  }
  if (!requesterId) {
    return 'Sign in to check financial-data access.';
  }
  if (permissionsLoading) {
    return 'Checking your permissions…';
  }
  if (
    isSupportPreview ||
    permissions?.isViewOnly ||
    permissions?.canEditEntity !== true ||
    permissions?.canViewFinancialData !== true
  ) {
    return 'Your role does not permit generating financial reports.';
  }
  if (tenantLoading) {
    return 'Checking financial-data availability…';
  }
  if (tenantError || !tenant) {
    return 'Financial-data settings could not be loaded. Check financials access again to retry.';
  }
  if (tenant.isDNBFinancialDataEnabled !== true) {
    return 'Financial Data is disabled for this tenant. Ask your platform administrator to enable it.';
  }
  return '';
}

export function getFinancialReportDisabledReason({
  eligibility,
  eligibilityLoading,
  eligibilityError,
  ...localAccess
} = {}) {
  const localReason = getFinancialReportLocalDisabledReason(localAccess);
  if (localReason) return localReason;
  if (eligibilityLoading) return 'Checking financial-data service access…';
  if (eligibilityError?.response?.status === 401) {
    return 'Your session could not be verified. Sign in again, then check financials access.';
  }
  if (eligibilityError?.response?.status === 403) {
    return 'Your account is not authorized to retrieve financial statements for this company.';
  }
  if (eligibilityError?.response?.status === 404) {
    return 'Financial-data access could not be verified because the service or company is unavailable. Contact your platform administrator.';
  }
  if (eligibilityError || eligibility?.success !== true || typeof eligibility?.data?.eligible !== 'boolean') {
    return 'Financial-data access could not be checked. Check financials access again to retry.';
  }
  if (eligibility.data.eligible !== true) {
    return typeof eligibility.data.message === 'string' && eligibility.data.message.trim()
      ? eligibility.data.message
      : 'Financial-data retrieval is not available for this company. Contact your platform administrator.';
  }
  return '';
}
